/**
 * 品牌管理相关接口
 */

/**
 *查询品牌信息 根据分页查找TLogOperationRecord
 */

export const logOperationRecord = '/log-operation-record'
/**
 * 修改品牌信息
 */
export const modifyBrand = '/uc-service/tenantBrand/modifyBrand'
/**
 * 上传头像
 */
export const uploadFile = 'basic-service/loadFile_1'



// WEBPACK FOOTER //
// ./src/api/brand.js